export default {
  // Inventory
  "no_films_found": "Keine Filme gefunden, die übereinstimmen mit",
  "no_films_yet": "Du hast noch keine Filmrollen",
  "add_first_film": "Füge deinen ersten Film hinzu",
  "no_lenses_found": "Keine Objektive gefunden, die übereinstimmen mit",
  "no_lenses_yet": "Du hast noch keine Objektive",
  "add_first_lens": "Füge dein erstes Objektiv hinzu",
  "no_cameras_found": "Keine Kameras gefunden, die übereinstimmen mit",
  "no_cameras_yet": "Du hast noch keine Kameras",
  "add_first_camera": "Füge deine erste Kamera hinzu",
  "no_items_inventory": "Keine Gegenstände in deinem Inventar",
  "inventory_management": "Inventar-Management",
  "film": "Film",
  "cameras": "Kameras",
  "lenses": "Objektive",
  "search_films": "Filme suchen...",
  "search_lenses": "Objektive suchen...",
  "search_cameras": "Kameras suchen...",
  "add_lens": "Objektiv hinzufügen",
  "add_film": "Film hinzufügen",
  "add_camera": "Kamera hinzufügen",
  "add_new_lens": "Neues Objektiv hinzufügen",
  "add_new_film": "Neuen Film hinzufügen",
  "add_new_camera": "Neue Kamera hinzufügen",
  "add_lens_details": "Fülle die Details unten aus, um ein neues Objektiv zu deinem Inventar hinzuzufügen.",
  "add_film_details": "Fülle die Details unten aus, um einen neuen Film zu deinem Inventar hinzuzufügen.",
  "add_camera_details": "Fülle die Details unten aus, um eine neue Kamera zu deinem Inventar hinzuzufügen.",
  "essential_info": "Grundlegende Infos",
  "optional_details": "Optionale Details",
  "brand": "Marke",
  "lens_name": "Objektivname/Modell",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8, usw.",
  "brand_placeholder": "Nikon, Canon, usw.",
  "film_name": "Filmname",
  "film_name_placeholder": "Portra 400, HP5 Plus, usw.",
  "camera_name": "Kameraname/Modell",
  "camera_name_placeholder": "AE-1, F3, Leica M6, usw.",
  "mount": "Anschluss",
  "mount_placeholder": "z.B. EF, M42",
  "mount_description": "Max. 4 alphanumerische Zeichen (z.B. EF, M42)",
  "status": "Status",
  "select_status": "Status auswählen",
  "working": "Funktioniert",
  "needs_repair": "Reparaturbedürftig",
  "for_parts": "Für Ersatzteile",
  "serial_number": "Seriennummer (Optional)",
  "purchase_date": "Kaufdatum (Optional)",
  "purchase_price": "Kaufpreis (Optional)",
  "notes": "Notizen (Optional)",
  "notes_placeholder": "Zusätzliche Notizen zu diesem Artikel",
  "next_step": "Nächster Schritt",
  "update_lens": "Objektiv aktualisieren",
  "update_film": "Film aktualisieren",
  "update_camera": "Kamera aktualisieren",
  "edit_film": "Film bearbeiten",
  "edit_lens": "Objektiv bearbeiten",
  "edit_camera": "Kamera bearbeiten",
  "update_film_details": "Aktualisiere deine Filmdetails unten",
  "update_lens_details": "Aktualisiere deine Objektivdetails unten",
  "update_camera_details": "Aktualisiere deine Kameradetails unten",
  "delete_film": "Film löschen",
  "delete_lens": "Objektiv löschen",
  "delete_camera": "Kamera löschen",
  "confirm_delete_film": "Bist du sicher, dass du löschen möchtest",
  "confirm_delete_lens": "Bist du sicher, dass du löschen möchtest",
  "confirm_delete_camera": "Bist du sicher, dass du löschen möchtest",
  "from_your_inventory": "aus deinem Inventar",
  "action_cannot_undone": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "film_removed_inventory": "Film aus dem Inventar entfernt",
  "lens_removed_inventory": "Objektiv aus dem Inventar entfernt",
  "camera_removed_inventory": "Kamera aus dem Inventar entfernt",
  "failed_delete_film": "Löschen des Films fehlgeschlagen",
  "failed_delete_lens": "Löschen des Objektivs fehlgeschlagen",
  "failed_delete_camera": "Löschen der Kamera fehlgeschlagen",
  "cannot_delete_film_missing_id": "Film kann nicht gelöscht werden, ID fehlt",
  "cannot_delete_lens_missing_id": "Objektiv kann nicht gelöscht werden, ID fehlt",
  "cannot_delete_camera_missing_id": "Kamera kann nicht gelöscht werden, ID fehlt",
  "film_updated_successfully": "Film erfolgreich aktualisiert",
  "lens_updated_successfully": "Objektiv erfolgreich aktualisiert",
  "camera_updated_successfully": "Kamera erfolgreich aktualisiert",
  "error_updating_film": "Fehler beim Aktualisieren des Films",
  "error_updating_lens": "Fehler beim Aktualisieren des Objektivs",
  "error_updating_camera": "Fehler beim Aktualisieren der Kamera",
  "cannot_update_film_missing_id": "Film kann nicht aktualisiert werden, ID fehlt",
  "cannot_update_lens_missing_id": "Objektiv kann nicht aktualisiert werden, ID fehlt",
  "cannot_update_camera_missing_id": "Kamera kann nicht aktualisiert werden, ID fehlt",
  "all": "Alle",
  "all_film": "Alle Filme",
  "all_lenses": "Alle Objektive",
  "all_cameras": "Alle Kameras",
  "unexposed": "Unbelichtet",
  "fresh": "Neu",
  "exposed": "Belichtet",
  "expired": "Abgelaufen",
  "developed": "Entwickelt",
  "transferring": "Übertrage:",
  "quantity_expose": "Zu belichtende Menge",
  "notes_optional": "Notizen (optional)",
  "mark_exposed": "Als belichtet markieren",
  "mark_film_exposed": "Film als belichtet markieren",
  "transfer_film_description": "Film von deinem Inventar in deine belichtete Sammlung übertragen.",
  "signin_required_inventory": "Du musst angemeldet sein, um dein Inventar zu sehen",
  "film_details": "Filmdetails",
  "lens_details": "Objektivdetails",
  "camera_details": "Kameradetails",
  "last_updated": "Zuletzt aktualisiert",
  "type": "Typ",
  "quantity": "Menge",
  "expiration_date": "Ablaufdatum",
  "expiration": "Ablauf",
  "focal_length": "Brennweite",
  "aperture": "Blende",
  "iso": "ISO",
  "film_type": "Filmtyp",
  "color": "Farbe",
  "black_and_white": "Schwarz-Weiß",
  "slide": "Dia",
  "camera_type": "Kameratyp",
  "slr": "SLR",
  "dslr": "DSLR",
  "mirrorless": "Spiegellos",
  "rangefinder": "Messucher",
  "point_and_shoot": "Kompaktkamera",
  "instant_film": "Sofortbild",
  "compatible_cameras": "Kompatible Kameras",
  "compatible_lenses": "Kompatible Objektive",
  "compatible_films": "Kompatible Filme",
  "are_you_absolutely_sure": "Bist du absolut sicher?",
  "model": "Modell",
  "error_loading_cameras": "Fehler beim Laden der Kameras",
  "camera_added_successfully": "Kamera erfolgreich hinzugefügt",
  "error_adding_camera": "Fehler beim Hinzufügen der Kamera",
  "adapter_enabled": "Adapter aktiviert",
  "adapter_mounts": "Adapter-Anschlüsse",
  "select_format": "Format auswählen",
  "select_camera_type": "Kameratyp auswählen",
  "format": "Format",
  "medium_format": "Mittelformat",
  "large_format": "Großformat",
};
